import { render, staticRenderFns } from "./GlassDamagesList.vue?vue&type=template&id=656c9f65&scoped=true"
import script from "./GlassDamagesList.vue?vue&type=script&lang=ts"
export * from "./GlassDamagesList.vue?vue&type=script&lang=ts"
import style0 from "./GlassDamagesList.vue?vue&type=style&index=0&id=656c9f65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c9f65",
  null
  
)

export default component.exports